import Vue from 'vue'
/* This file is too big, try not to use it it will cause the app to lag
Alternatively only store productions in process here
*/
const state = {
  productionInputs: {}
}

const mutations = {
  FETCH_INPUTS (state, productionInputs) {
    state.productionInputs = productionInputs
  }
}

const actions = {
  fetchProductionInputs: ({commit}) => {
    return Vue.prototype.$axios.get('production-inputs')
      .then(response => {
        commit('FETCH_INPUTS', response.data)
      })
  }
}

const getters = {
  getProductionInputs: state => productionID => {
    return Object.values(state.productionInputs).filter(item => {
      return item.production_id === productionID
    })
  },
  getInputById: state => inputID => {
    return state.productionInputs[inputID]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
